import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

const CurrenciesPage = lazy(() => import("@/pages/currencies/CurrenciesPage"));
const CurrencyCreatePage = lazy(() => import("@/pages/currencies/CurrencyCreatePage"));
const CurrencyEditPage = lazy(() => import("@/pages/currencies/CurrencyEditPage"));

export function CurrencyRoutes() {
  return (
    <>
      <Route path="currencies" element={<ProtectedRoute><CurrenciesPage /></ProtectedRoute>} />
      <Route path="currencies/new" element={<ProtectedRoute><CurrencyCreatePage /></ProtectedRoute>} />
      <Route path="currencies/:id/edit" element={<ProtectedRoute><CurrencyEditPage /></ProtectedRoute>} />
    </>
  );
}
